import { useState } from "react";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

import {
  type AdvancedBreakdownDescriptor,
  type AdvancedSegmentDescriptor,
} from "../types";
import { validateAdvancedSegment } from "../utils";

import { SegmentForm } from "./segment-form";

interface Props {
  isUpdate: boolean;
  breakdown: AdvancedBreakdownDescriptor;
  segment: AdvancedSegmentDescriptor | null;
  onClose: () => void;
  onUpdate: (segment: AdvancedSegmentDescriptor) => void;
}

export const SegmentModal = (props: Props) => {
  return (
    <Modal
      size="3xl"
      isOpen={!!props.segment}
      titleContent={
        <h3 className="heading mx-0 mb-0 mt-0 font-bold text-[1.5rem] max-w-[1000px] leading-8">
          Editing rule for “{props.breakdown.name}” breakdown
        </h3>
      }
      onClose={props.onClose}
    >
      {props.segment ? (
        <Content {...props} segment={props.segment} />
      ) : (
        <div className="h-[90vh]"></div>
      )}
    </Modal>
  );
};

const Content = ({
  isUpdate,
  breakdown,
  segment,
  onClose,
  onUpdate,
}: Props) => {
  const [localSegment, setLocalSegment] = useState(segment!);

  return (
    <div>
      <div className="mt-3">
        <SegmentForm
          breakdown={breakdown}
          segment={localSegment}
          onChange={(value) => setLocalSegment(value)}
        />
      </div>
      <div className="flex items-center justify-end gap-2">
        <TertiaryButton className="ml-2 font-bold" onClick={onClose}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          className="font-bold"
          onClick={() => {
            const validatedSegment = validateAdvancedSegment(localSegment);
            const errors = validatedSegment.errors;

            if (
              errors.name ||
              errors.output ||
              errors.level ||
              errors.matcher ||
              errors.priority
            ) {
              setLocalSegment(validatedSegment);
            } else {
              onUpdate(validatedSegment);
            }
          }}
        >
          {isUpdate ? "UPDATE" : "CREATE"}
        </PrimaryButton>
      </div>
    </div>
  );
};
